module.exports = __webpack_public_path__ + "session2-61730864.webp";